module.exports = __webpack_public_path__ + "frontend/images/agents/mr-tan-just-moved-d4b309431815519e33bd887d42736767.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/agents/mr-tan-just-moved.jpg
// module id = 360
// module chunks = 2